'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPopOpenWelcomeMessage = undefined;

var _reselect = require('reselect');

var _getWelcomeMessage = require('./getWelcomeMessage');

var getPopOpenWelcomeMessage = exports.getPopOpenWelcomeMessage = (0, _reselect.createSelector)(_getWelcomeMessage.getWelcomeMessage, function () {
  var welcomeMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return !!welcomeMessage.popOpenWelcomeMessage;
});